export const config = {
  // API Configuration
  apiUrl: process.env.REACT_APP_JOB_APP_API_URL || "http://localhost:8000",

  // URL Configuration
  mainUrl: process.env.REACT_APP_JOB_APP_MAIN_URL || "http://localhost:3000",
  baseUrl: process.env.REACT_APP_JOB_APP_BASE_URL || "http://localhost:3000",

  // Asset Configuration for branding fir
  assetUrl: process.env.REACT_APP_JOB_APP_ASSET_URL || "",
  assetBrandName: process.env.REACT_APP_ASSET_BRAND_NAME || "firestorm",
  companyName: process.env.REACT_APP_COMPANY_NAME || "Firestorm",
  companyNameFull: process.env.REACT_APP_COMPANY_NAME_FULL || "Firestorm Wildland Fire Suppression, Inc.",
  companyNameAbbr: process.env.REACT_APP_COMPANY_NAME_ABBR || "Firestorm W.F.S. Inc",
  companyNameLegal: process.env.REACT_APP_COMPANY_NAME_LEGAL || "FIRESTORM WFS INC",
  companyNameWildland: process.env.REACT_APP_COMPANY_NAME_WILDLAND || "Firestorm Wildland Fire",
  companyNameSms: process.env.REACT_APP_COMPANY_NAME_SMS || "Firestorm Wildland Fire Suppression, Inc.",
  companyAddress: process.env.REACT_APP_COMPANY_ADDRESS || "1100 FORTRESS ST. #2, CHICO, CA 95973",
  companyPhone: process.env.REACT_APP_COMPANY_PHONE || "530-898-8153",

  // Social Login Configuration
  facebookAppId: process.env.REACT_APP_JOB_APP_FACEBOOK_APP_ID || "",
  googleAppId: process.env.REACT_APP_JOB_APP_GOOGLE_APP_ID || "",

  // Sentry Configuration
  dsn: process.env.REACT_APP_JOB_APP_DSN || "",

  //DOCS URL Configuration
  docUrl: process.env.REACT_APP_DOC_URL || "",

  // Logo Display Configuration
  showLogo: !(process.env.REACT_APP_SHOW_LOGO === 'false' || process.env.REACT_APP_SHOW_LOGO === '0'), // Defaults to true, set to 'false' or '0' to hide logo

  // API Helper Method
  _api: (endpoint) => {
    const apiUrl = config.apiUrl || "http://localhost:8000";
    // Remove trailing slash from apiUrl
    const baseUrl = apiUrl.replace(/\/$/, "");
    // Remove leading slash from endpoint
    const cleanEndpoint = endpoint.startsWith("/") ? endpoint.substring(1) : endpoint;
    // Construct full API URL
    return `${baseUrl}/api/${cleanEndpoint}`;
  },
};
